module.exports = __webpack_public_path__ + "media/newstyle/images/icon-submarino-ac2e3f6a5a17f92ba75e66510d28dcaf.svg";